import axios from "axios";
import { HttpCodes } from "../../../modules/constants";

const SET_SITES = "SET_SITES";
const SET_PARTICIPANT_DETAILS = "SET_PARTICIPANT_DETAILS";
const LOGOUT = "LOGOUT";

const getSites = (state) => state.sites;
const getChosenSite = (state) =>
  state.loginReducer.sites?.length > 0 ? state.loginReducer.sites[0] : {};
const getParticipantDetails = (state) => state.participantDetails;

// Default state
const initialState = {
  sites: [],
  participantDetails: null,
};

export const editParticipantReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SITES:
      const { sites } = action;

      return {
        ...state,
        sites,
      };
    case SET_PARTICIPANT_DETAILS:
      const { participantDetails } = action;

      return {
        ...state,
        participantDetails,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export const resetParticipantDetails = () => (dispatch) => {
  return dispatch({ type: SET_PARTICIPANT_DETAILS, participantDetails: null });
};

const updateParticipant = (formData) => (dispatch, getState) => {
  return axios
    .put(`/api/participant/update`, formData)
    .then(() => {
      return Promise.resolve("Participant updated successfully!");
    })
    .catch((err) => {
      let errorMessage =
        "There was an error while trying to update the participant!";

      if (err.response.status === HttpCodes.CONFLICT) {
        errorMessage =
          "The Participant ID you have entered is already registered.";
      }
      return Promise.reject(errorMessage);
    });
};

const fetchParticipantDetails = (participantId) => (dispatch) => {
  const params = {
    participantId,
  };

  return axios
    .get(`/api/participant/info`, { params })
    .then(({ data }) => {
      dispatch({ type: SET_PARTICIPANT_DETAILS, participantDetails: data });
    })
    .catch(() => {});
};

export const fetchSites = (studyId) => (dispatch) => {
  const params = {
    studyId,
  };

  return axios
    .get(`/api/study/sites`, { params })
    .then(({ data }) => {
      const sites = data?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      dispatch({ type: SET_SITES, sites: sites });
    })
    .catch(() => {});
};

export const mapStateToProps = (state) => {
  return {
    sites: getSites(state),
    chosenSite: getChosenSite(state),
    participantDetails: getParticipantDetails(state),
  };
};

export const mapDispatchToProps = {
  updateParticipant,
  fetchSites,
  fetchParticipantDetails,
  resetParticipantDetails,
};
